export const quotes = [
    "The only limit to our realization of tomorrow is our doubts of today.",
    "Success is not final, failure is not fatal: It is the courage to continue that counts.",
    "It does not matter how slowly you go as long as you do not stop.",
    "The future belongs to those who believe in the beauty of their dreams.",
    "Believe you can and you're halfway there.",
    "Your time is limited, don’t waste it living someone else’s life.",
    "I have not failed. I've just found 10,000 ways that won't work.",
    "It always seems impossible until it's done.",
    "You miss 100% of the shots you don’t take.",
    "The best way to predict the future is to create it.",
    "Success is the sum of small efforts, repeated day-in and day-out.",
    "Happiness is not something ready made. It comes from your own actions.",
    "In the end, we only regret the chances we didn’t take.",
    "Hardships often prepare ordinary people for an extraordinary destiny.",
    "Dream big and dare to fail.",
    "The best time to plant a tree was 20 years ago. The second best time is now.",
    "Don't watch the clock; do what it does. Keep going.",
    "Do what you can, with what you have, where you are.",
    "The only way to do great work is to love what you do.",
    "Challenges are what make life interesting and overcoming them is what makes life meaningful.",
    "You are never too old to set another goal or to dream a new dream.",
    "Don’t count the days, make the days count.",
    "Life is 10% what happens to us and 90% how we react to it.",
    "Believe in yourself and all that you are. Know that there is something inside you that is greater than any obstacle.",
    "The only way to achieve the impossible is to believe it is possible.",
    "If you're going through hell, keep going.",
    "Success usually comes to those who are too busy to be looking for it.",
    "If you want to achieve greatness stop asking for permission.",
    "Don’t be afraid to give up the good to go for the great.",
    "What we think, we become."
  ];
  